import React, { Component } from "react";
import Render from "../../../components/Renderer";
import { Table, Divider, Switch, message, Popover } from "antd";
import { isReadOnly } from "../../../utils/permission";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import validatejs from "validate.js";
import { table as tConstraints, Constraints } from "./Constraints";
import { connect } from "react-redux";
import { getGate, getTerminal } from "../../../redux/actions/dropdown";
import {
  insertGate,
  deleteGate,
  getListSettingGate,
  updateStatusGate
} from "../../../redux/actions/setting";

class GateAdd extends Component {
  state = {
    form: {},
    data: [],
    disabledSave: false,
    visible: {},
    filterTerminal: []
  };

  componentDidMount() {
    const data = [{ key: 1, isError: true, display: true }];
    this.setState({ data, errors: validatejs({}, Constraints) });
    this.setFilterTerminal();
  }

  search = () => {
    let { form } = this.state;
    let param = "";
    if (form.airportId !== undefined && form.terminalId !== undefined) {
      param = "airportId=" + form.airportId;
      param += "&terminalId=" + form.terminalId;
      this.getList(param);
    }
  };

  getList = param => {
    this.props.getListSettingGate(param).then(res => {
      this.setState({ isLoading: false });
      if (res && res.payload.status === 200 && res.type.endsWith("SUCCESS")) {
        let data = res.payload.data.data;
        data.push({ isEnable: 1 });
        this.setState({
          data: data.map((d, i) => ({
            key: i,
            airportId: d.airportId,
            terminalId: d.terminalId,
            gateId: d.gateId,
            gateEN: d.gateNameEN,
            gateTH: d.gateNameTH,
            remark: d.remark,
            display: d.isEnable === 1,
            flightScope: d.flightScope,
          }))
        });
      }
    });
  };

  setFilterTerminal = () => {
    this.props.getTerminal().then(res => {
      if (res && res.payload.status === 200 && res.type.endsWith("SUCCESS")) {
        let data = res.payload.data.data;
        this.setState({
          filterTerminal: data
        });
      }
    });
  };

  onDelete = (item, index) => {
    let { data } = this.state;
    data.splice(index, 1);
    this.setState({ data });
    if (item.gateId) this.onDeleteOnline(item);
    let { visible } = this.state;
    visible[index] = false;
    this.setState({ visible });
  };

  onAdd = () => {
    let { data } = this.state;
    data.push({ key: data.length + 1, display: true });
    this.setState({ data });
  };

  onChange = ({ name, value, error }) => {
    let { form, errors } = this.state;
    form[name] = value;
    if (name === "airportId") delete form.terminalId;
    if (errors === undefined) errors = {};
    if (error === undefined) delete errors[name];
    else errors[name] = error.join();
    if (Object.keys(errors).length === 0) errors = undefined;
    this.setState(
      { form, errors, data: [{ key: 1, isError: true, display: true }] },
      this.search
    );
  };

  onChangeTable = (index, name, value) => {
    let { data } = this.state;
    data[index][name] = value;
    for (let item of data) {
      const valid = validatejs(item, tConstraints);
      item.isError = valid !== undefined;
    }
    this.setState({ data });
  };

  renderInput = (name, row, index) => {
    var template = {
      type: "input",
      name: name,
      value: row[name],
      disabled: row.gateId !== undefined,
      placeholder: ""
    };
    return Render(template, ({ name, value }) =>
      this.onChangeTable(index, name, value)
    );
  };

  renderSelect = (name, row, index) => {
    const template = {
      type: "select",
      name: name,
      label: "Flight Scope",
      value: row[name],
      options: {
        name: 'flightScope',
        id: 'id',
        text: 'label',
        dataLoad: 1,
        dataService: [
          { id: 'domestic', label: 'Domestic' },
          { id: 'inter', label: 'Inter' },
          { id: 'both', label: 'Both' },
        ]
      }
    }
    return Render(template, ({ name, value }) =>
      this.onChangeTable(index, name, value)
    );
  };

  onDeleteOnline = item => {
    this.props.deleteGate(item.gateId).then(res => {
      if (res && res.payload.status === 200 && res.type.endsWith("SUCCESS")) {
        message.success("Delete Gate success");
        this.props.getGate();
      }
    });
  };

  onSave = () => {
    this.setState({ disabledSave: true }, () => {
      const { form, data } = this.state;
      const clean = data.filter(x => !x.isError && x.gateId === undefined);
      const body = {
        airportId: form.airportId,
        terminalId: form.terminalId,
        listGate: clean.map(x => ({
          gateTH: x.gateTH,
          gateEN: x.gateEN,
          remark: x.remark,
          isEnable: x.display ? 1 : 0,
          flightScope: x.flightScope
        }))
      };
      this.props.insertGate(body).then(res => {
        setTimeout(() => {
          this.setState({ disabledSave: false });
        }, 500);
        if (res.status === 400) {
          message.error("ไม่สามารถเพิ่มข้อมูลได้");
        } else if (
          res &&
          res.payload.status === 200 &&
          res.type.endsWith("SUCCESS")
        ) {
          message.success("Insert Gate success");
          this.props.getGate();
          this.props.onClose(this.props.name);
        }
      });
    });
  };

  edit = item => this.props.onEdit(this.props.name, item);

  refresh = () => {
    this.props.onRefreshDone();
    setTimeout(() => {
      this.search();
    }, 200);
  };

  onCheckChange = (item, checked, index) => {
    if (item.gateId) {
      const body = {
        gateId: item.gateId,
        statusDisplay: checked ? 1 : 0
      };
      this.props.updateStatusGate(body).then(res => {
        if (res && res.payload.status === 200 && res.type.endsWith("SUCCESS")) {
          message.success("Update status success");
          this.search(true);
        }
      });
    } else {
      let { data } = this.state;
      data[index].display = checked;
      this.setState({ data });
    }
  };

  visibleChange = item => {
    let { visible } = this.state;
    visible[item] = false;
    this.setState({ visible });
  };

  render() {
    const { form, data, errors, disabledSave, filterTerminal } = this.state;
    const { refresh } = this.props;
    if (refresh) this.refresh();
    const readOnly = isReadOnly("airtypesetting");
    const template = [
      {
        type: "select",
        name: "airportId",
        label: "Airport",
        constraint: Constraints,
        value: form.airportId,
        placeholder: "Select Airport...",
        options: {
          name: "airportDOAOptions",
          id: "airportID",
          text: "airportName",
          preFilter: q => q.statusDisplay === 1
        }
      },
      {
        type: "select",
        name: "terminalId",
        constraint: Constraints,
        label: "Terminal",
        value: form.terminalId,
        placeholder: "Select Terminal...",
        options: {
          name: "terminalOptions",
          id: "terminalId",
          text: "terminalName",
          dataLoad: 1,
          dataService: filterTerminal,
          preFilter: x => x.airportId === form.airportId
        }
      }
    ];
    const columns = [
      {
        title: "Gate (ENG)",
        key: "gateEN",
        dataIndex: "gateEN",
        width: 150,
        render: (text, row, index) => this.renderInput("gateEN", row, index)
      },
      {
        title: "Gate (TH)",
        dataIndex: "gateTH",
        key: "gateTH",
        width: 150,
        render: (text, row, index) => this.renderInput("gateTH", row, index)
      },
      {
        title: "Flight scope",
        dataIndex: "flightScope",
        key: "flightScope",
        width: 150,
        render: (text, row, index) => this.renderSelect("flightScope", row, index)
      },
      {
        title: "Remark",
        dataIndex: "remark",
        key: "remark",
        width: 150,
        render: (text, row, index) => this.renderInput("remark", row, index)
      },
      {
        title: "Display (On/Off)",
        key: "display",
        width: 150,
        render: (text, row, index) => (
          <Switch
            disabled={readOnly}
            onChange={checked => this.onCheckChange(row, checked, index)}
            checked={row.display}
          />
        )
      },
      {
        title: "Edit",
        key: "edit",
        width: 80,
        render: item =>
          item.gateId && (
            <button
              disabled={readOnly}
              onClick={() => this.edit(item)}
              type="button"
              className="btn btn-outline-warning btn-sm"
            >
              <FontAwesomeIcon icon="pen" />
            </button>
          )
      },
      {
        title: "",
        key: "add",
        width: 80,
        render: (text, row, index) =>
          index + 1 === data.length ? (
            <button
              type="button"
              className="btn btn-sm btn-outline-success"
              onClick={() => {
                this.onAdd(index);
              }}
            >
              <FontAwesomeIcon icon="plus" />
            </button>
          ) : (
            <Popover
              visible={this.state.visible[index]}
              onVisibleChange={_visible => {
                let { visible } = this.state;
                visible[index] = _visible;
                this.setState({ visible });
              }}
              content={
                <div className="col">
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm mr-2"
                    onClick={() => {
                      this.onDelete(row, index);
                    }}
                  >
                    Delete
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => this.visibleChange(index)}
                  >
                    Cancel
                  </button>
                </div>
              }
              title="Are you sure?"
              trigger="click"
            >
              <button
                type="button"
                className="btn btn-sm btn-outline-danger"
                // onClick={() => {
                //   this.onDelete(row, index);
                // }}
                onClick={this.delete}
              >
                <FontAwesomeIcon icon="trash" />
              </button>
            </Popover>
          )

        // <button
        //   onClick={() => {
        //     index + 1 === data.length
        //       ? this.onAdd(index)
        //       : this.onDelete(row, index);
        //   }}
        //   type="button"
        //   className={
        //     "btn btn-sm " +
        //     (index + 1 === data.length
        //       ? "btn-outline-success"
        //       : "btn-outline-danger")
        //   }
        // >
        //   <FontAwesomeIcon
        //     icon={index + 1 === data.length ? "plus" : "trash"}
        //   />
        // </button>
      }
    ];
    const sum = columns.reduce((a, b) => a + b.width, 0);
    const table = (
      <Table
        bodyStyle={{ minHeight: 260 }}
        style={{ minWidth: 600 }}
        pagination={false}
        scroll={{ x: sum + "px" }}
        className="tbody-center bg-white"
        rowClassName={(record, index) => {
          if (record.isError && index !== data.length - 1) return "bg-danger";
        }}
        columns={columns}
        dataSource={data}
      />
    );
    return (
      <div className="card card-body card-body-component">
        <button
          type="button"
          onClick={() => this.props.onClose(this.props.name)}
          className="btn btn-success"
          style={{ width: 100 }}
        >
          <FontAwesomeIcon icon="angle-double-left" />
          <span className="ml-2">Back</span>
        </button>
        {template.map((data, i) => {
          return (
            <div key={i} className="form-row form-inline mb-2 col-12 px-0">
              <label className="col-lg-2 col-md-3 col-sm-4 col-5 justify-content-end">
                {data.label} :
              </label>
              <div className="col-lg-4 col-md-6 col-sm-8 col-12">
                {Render(data, this.onChange)}
              </div>
            </div>
          );
        })}
        {table}
        <Divider />
        {/* footer */}
        <div className="text-center mt-2">
          <button
            onClick={() => this.props.onClose(this.props.name)}
            className="btn btn-light mr-2"
          >
            Cancel
          </button>
          <button
            disabled={errors !== undefined || disabledSave}
            onClick={this.onSave}
            className="btn btn-success mr-2"
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  language: state.language
});

const mapDispatchToProps = dispatch => ({
  getListSettingGate: param => dispatch(getListSettingGate(param)),
  insertGate: body => dispatch(insertGate(body)),
  deleteGate: id => dispatch(deleteGate(id)),
  getGate: () => dispatch(getGate()),
  updateStatusGate: body => dispatch(updateStatusGate(body)),
  getTerminal: () => dispatch(getTerminal())
});

export default connect(mapStateToProps, mapDispatchToProps)(GateAdd);
